import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Keyed by location.pathname
  // e.g., "/pages/libriMatricola": { searchText: "", currentPage: 0, pageSizeState: 5 }
  grids: {}
};

export const slice = createSlice({
  name: 'dynamicGridFilters',
  initialState,
  reducers: {
    setGridState(state, action) {
      const { path, searchText, currentPage, pageSizeState } = action.payload;
      state.grids[path] = { searchText, currentPage, pageSizeState };
    },
    clearGridState(state, action) {
      const { path } = action.payload;
      if (state.grids[path]) {
        delete state.grids[path];
      }
    }
  }
});

export const { setGridState, clearGridState } = slice.actions;
export default slice.reducer;
